/**
 * Roadmap Comment Like Remapper
 * Flutter: lib/data/models/roadmap_comment_like.dart
 */
import type { RoadmapCommentLikeDto } from '@/data/dtos/roadmapCommentLike/roadmapCommentLikeDto';
import type { JsonObject } from '@/data/types/json';
import type { RoadmapCommentLikeStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class RoadmapCommentLikeRemapper {
  static toStorage(dto: RoadmapCommentLikeDto): RoadmapCommentLikeStorage {
    return {
      userId: dto.userId,
      commentId: dto.commentId,
      parentCommentId: dto.parentCommentId,
      liked: dto.liked,
      createdDate: dto.createdDate,
      updatedDate: dto.updatedDate,
    };
  }

  static fromJson(data: JsonObject): RoadmapCommentLikeDto {
    return {
      userId: (data['userId'] as string | undefined) ?? '',
      commentId: (data['commentId'] as string | undefined) ?? '',
      parentCommentId: data['parentCommentId'] as string | undefined,
      liked: (data['liked'] as boolean | undefined) ?? false,
      createdDate: (data['createdDate'] as number | undefined) ?? 0,
      updatedDate: data['updatedDate'] as number | undefined,
    };
  }

  static fromJsonList(dataList: JsonObject[]): RoadmapCommentLikeDto[] {
    return dataList.map(RoadmapCommentLikeRemapper.fromJson);
  }

  static toJson(dto: RoadmapCommentLikeDto): JsonObject {
    return {
      userId: dto.userId,
      commentId: dto.commentId,
      parentCommentId: dto.parentCommentId ?? null,
      liked: dto.liked,
      createdDate: dto.createdDate,
      updatedDate: dto.updatedDate ?? null,
    };
  }
}
